import React from 'react';
import { string, func, bool } from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import InputBase from '@material-ui/core/InputBase';

const propTypes = {
	label: string,
	error: string,
	onChange: func,
	isValid: bool,
};

const defaultProps = {
	error: '',
	isValid: false,
};

const useStyles = makeStyles({
	input: {
		color: '#333f4b',
		borderColor: '#c7c7c7',
		fontFamily: 'Open Sans',
		fontSize: '16px',
		padding: '0px 8px',
		display: 'flex',
		alignItems: 'center',
		height: '48px',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderRadius: '4px',
		backgroundColor: '#ffffff',
	},
	inputError: {
		color: '#c9311a',
		borderColor: '#c9311a',
	},
	inputValid: {
		color: '#333f4b',
		borderColor: '#2ca323',
	},
	label: {
		fontWeight: '600',
		fontSize: '14px',
		color: '#333f4b',
		textDecoration: 'none solid rgb(51, 63, 75)',
		letterSpacing: '0.1px',
		marginBottom: '9px',
	},
	containar: {
		display: 'flex',
		flexDirection: 'column',
	},
	error: {
		fontSize: '12px',
		color: '#c9311a',
		textDecoration: 'none solid rgb(201, 49, 26)',
		letterSpacing: '0.4px',
		marginTop: '3px',
	},
});

function TextField(props) {
	const { label, error, isValid, ...otherProps } = props;
	const classes = useStyles();

	return (
		<div className={classes.containar}>
			<label className={classes.label}>{label}</label>
			<InputBase
				className={classNames(
					classes.input,
					{ [classes.inputError]: Boolean(error) },
					{ [classes.inputValid]: isValid }
				)}
				{...otherProps}
			/>
			{Boolean(error) && <span className={classes.error}>{error}</span>}
		</div>
	);
}

TextField.propTypes = propTypes;
TextField.defaultProps = defaultProps;

export default TextField;
